// @ts-nocheck
import { delay, call, put, takeLatest } from 'redux-saga/effects';
import type { Saga } from 'redux-saga';
import api from 'lib/Api';
import alertActions from 'ducks/alert/actions';
import { alertTypesConstants } from 'commons/constants';
import type { GetExpertsRequestPayload } from 'commons/types';
import { getExpertsTypes } from './types';
import expertsActions from './actions';

const { DANGER } = alertTypesConstants;
export function* getExpertsSaga({ payload }: { payload: GetExpertsRequestPayload }): Saga {
  try {
    yield delay(300);
    const response = yield call([api.expert, 'getAll'], payload);
    const { tab, page } = payload;
    const currentPage = page - 1;
    yield put(expertsActions.getExpertsSuccess({ ...response, tab, currentPage }));
  } catch (error) {
    const message = 'An error occurred while getting the experts';
    yield put(
      alertActions.setAlert({
        message,
        type: DANGER,
      }),
    );
    yield put(expertsActions.getExpertsFailed(message));
  }
}
export default function* expertSaga(): Saga {
  yield takeLatest(getExpertsTypes.REQUEST, getExpertsSaga);
}
